const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_auth/session-expired.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/session-expired')({
  beforeLoad: async () => {
    if (!(await waitForAuth())) throw redirect({
      to: LOGIN_ROUTE,
      replace: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});